/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import Loading from 'components/Loading/Loading';

import type TypeForm from 'forms/_.extend';

import ElectroSelectWithOther from 'forms/components/inputs/ElectroSelectWithOther/ElectroSelectWithOther';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  t: TranslatorProps,
  asset: Object,
  form: TypeForm,
  assetStore: Object,
};

@translate()
@inject('assetStore')
@observer
export default class RequestAssetOwnershipForm extends React.Component<*> {
  render(): React.Fragment {
    const { t, asset, form, assetStore }: TypeProps = this.props;

    const assetDetails: Object = asset.account ? asset : assetStore.asset;

    let details: Array<*> = [
      [t('general:assets.labels.number'), assetDetails.asset_number],
      [t('general:manufacturer'), assetDetails.manufacturer],
      [t('general:model'), assetDetails.model],
      [t('general:labels.serial_number'), assetDetails.serial_number],
    ];

    if (assetDetails.contract) {
      details = [[t('general:trading_account'), assetDetails.contract.company_name]].concat(
        details
      );
    }

    if (!assetStore.asset.account) {
      return <Loading />;
    }

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:assets.labels.details')}
          >
            <ActionDrawerTable data={details} />
          </ActionDrawerBlock>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:assets.currently_assigned_to')}
          >
            <ul>
              <li>{assetDetails.user && assetDetails.user.name}</li>
              <li>
                {`${t('general:roles.labels.current_role')}:
                                ${assetDetails.user && assetDetails.user.role}`}
              </li>
            </ul>
          </ActionDrawerBlock>
          <ActionDrawerBlock gutters={true} heading={form.$('requestReason').label}>
            <ElectroSelectWithOther
              field={form.$('requestReason.reason')}
              otherHeading={`${t('general:reasons.provide_reason')} *`}
            />
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.request')} />
      </React.Fragment>
    );
  }
}
